import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type {
  CurrencyEnum,
  IApiError,
  IReduxRequestNode,
} from "@litres-libs/types";
import { Request } from "../../request/Request";

interface ISubscribeReducerState {
  subscriptions: ISubscriptionInfo[];
  litresSubscriptions: ISubscriptionInfo[];
  actions: {
    subscribeToItemCSRF: {
      [keyId: string]: IReduxRequestNode<
        ISubscribeToItemParams,
        ISubscribeToItemPayload
      >;
    };
  };
}

const initialState: ISubscribeReducerState = {
  subscriptions: [],
  litresSubscriptions: [],
  actions: {
    subscribeToItemCSRF: {},
  },
};

export interface ISubscribeToItemParams {
  subscr: "always" | "never" | "default";
  entity: "person" | "sequence" | "tag";
  id: number;
}

export interface ISubscribeToItemPayload {
  success?: boolean;
  error?: boolean;
}
export enum ESubscriptionType {
  abonement_without_discount = 11,
  abonement_with_discount = 13,
  litres_subscription = 14,
}

export interface IGetSubscriptionRequest {
  subscription_type?: ESubscriptionType;
}

export interface ISubscriptionInfo {
  class_id: number;
  currency: CurrencyEnum;
  duration: number;
  discount: number;
  price: number;
  promo_price?: number;
}

export interface IGetSubscriptionResponse {
  error?: IApiError;
  status: number;
  payload: {
    data: ISubscriptionInfo[];
  };
}

/**
 * Запрос поиска по текстовому ключу
 */
export const subscribeToItemCSRF = createAsyncThunk(
  "global/subscribe/subscribeToItemCSRF",
  async (params: ISubscribeToItemParams) => {
    const response = new Request.Cat2<
      ISubscribeToItemParams,
      ISubscribeToItemPayload
    >({
      url: "/",
      provider: {
        id: "w_subscr_to_item",
      },
      request: {
        method: "POST",
        params: params,
      },
    });

    return await response.fetch();
  }
);

export const subscriptionsToItemSlice = createSlice({
  name: "global/subscribe",
  initialState,
  reducers: {
    // Сеттеров нет
  },
  extraReducers: builder => {
    /**
     * Запрос на установку рейтинга для арта
     */
    builder.addCase(
      subscribeToItemCSRF.fulfilled,
      (
        state: ISubscribeReducerState,
        action: PayloadAction<
          IReduxRequestNode<ISubscribeToItemParams, ISubscribeToItemPayload>
        >
      ) => {
        // Берем ID арта из запроса, чтобы создать ноду с запросом/ответом на данный арт в редаксе
        const requestedId = action.payload.request?.request?.params?.id || 0;
        const requestedType =
          action.payload.request?.request?.params?.entity || "unknown";

        if (action.payload.response && action.payload.request) {
          state.actions.subscribeToItemCSRF[`${requestedType}-${requestedId}`] =
            action.payload;
        }

        // TODO: Ошибку точно не надо как-то визуально обработать в интерфейсе?
        if (action.payload.error) {
          console.error(
            "Ошибка запроса subscribeToItemCSRF",
            action.payload.error
          );
          state.actions.subscribeToItemCSRF[`${requestedType}-${requestedId}`] =
            {};
          state.actions.subscribeToItemCSRF[
            `${requestedType}-${requestedId}`
          ].error = action.payload.error;
        }
      }
    );
  },
});

export default subscriptionsToItemSlice.reducer;
